import {
  Component,
  EventEmitter,
  OnInit,
  Output,
  ViewChild,
} from '@angular/core';
import { NavController } from '@ionic/angular';
import { TranslateService } from '@ngx-translate/core';
import { InfiniteScroll } from 'src/app/interfaces/interfaces';
import { HttpService } from 'src/app/services/http.service';
import { UiServices } from 'src/app/services/ui-services';
import { SubscriptionService } from '../../pages-admin/subscriptions/services/subscription.service';
import { inscriptionDictionary } from 'src/app/pages/virtual-class/interfaces';

@Component({
  selector: 'app-subscription-user',
  templateUrl: './subscription-user.component.html',
  styleUrls: ['./subscription-user.component.scss'],
})
export class SubscriptionUserComponent implements OnInit {
  @ViewChild('infiniteScroll') set infiniteScroll(el: InfiniteScroll) {
    if (el) {
      this._infiniteScrollEl = el;
    }
  }
  @Output() emitInscriptionId$ = new EventEmitter<number>();
  private _infiniteScrollEl: InfiniteScroll = undefined;
  private _page = 1;
  private _totalPages = 1;
  private _search = '';
  public inscriptions = [];
  public inscriptionStatus = inscriptionDictionary;
  public loaded = false;

  constructor(
    private httpSv: HttpService,
    private uiSv: UiServices,
    private trSv: TranslateService,
    private navCtrl: NavController,
    private subscriptionSv: SubscriptionService
  ) {}

  async ngOnInit() {
    this._page = 1;
    await this.getUsers();
    this.loaded = true;
  }

  async getUsers() {
    try {
      const params = {
        pag: this._page,
        search: this._search,
      };
      const res = await this.httpSv.itemIndex('client/inscription', '', params);
      const data = res.data;
      const inscriptions: any[] = data.data;
      this._totalPages = data.meta.last_page;
      inscriptions.map((item) => {
        const renovation = new Date(item.renovation);
        const actualDate = new Date();
        if (actualDate >= renovation) {
          item.renovate = true;
        } else {
          item.renovate = false;
        }
      });

      this.inscriptions.push(...inscriptions);
      this._page++;
    } catch (err) {
      console.error(err);
    }
  }

  async loadData(event: InfiniteScroll) {
    event.disconnect();
    await this.getUsers();
    if (this._page >= this._totalPages) {
      event.complete();
    } else {
      event.observe();
    }
  }

  reset() {
    this.inscriptions = [];
    this._page = 1;
    this._infiniteScrollEl.setVisible();
    this._infiniteScrollEl.observe();
  }

  async onSearchChange(ev) {
    this._search = ev?.detail?.value || '';
    this._page = 1;
    this.inscriptions = [];
    await this.getUsers();
    setTimeout(() => {
      this._infiniteScrollEl.setVisible();
    });
  }

  async aproveInscription(inscription) {
    if (inscription.renovate) {
      let tr = '';
      let pendingApprove = false;
      if (inscription.status === 'Pagado') {
        tr = this.trSv.instant(
          'Debes aprobar el pago antes de continuar con la renovación'
        );
        pendingApprove = true;
      } else {
        tr = this.trSv.instant(
          'DESEAS_CONTINUAR_CON_LA_APROBACION_DE_LA_INSCRIPCION'
        );
      }
      const trTo = this.trSv.instant('PARA');
      const { role } = await this.uiSv.presentAlert(
        `${tr} "${inscription.name}" ${trTo} ${inscription.user[0].name}?`
      );

      if (role === 'accept') {
        const id = inscription.id;
        if (pendingApprove) {
          this.navCtrl.navigateForward('admin/paylist', {
            queryParams: {
              payment: inscription.payment[0].id,
            },
          });
        } else {
          const res = await this.httpSv.itemAction(
            { id },
            'admin',
            'renovation'
          );
          if (res.status) {
            this.onSearchChange('');
            inscription.renovate = true;
          }
        }
      }
    }
  }

  async suspend(inscription) {
    this.subscriptionSv.suspend(inscription);
  }
}
